
const productMenu = {
    hotel: 0, // 酒店
    ticket: 1, // 门票 景区
    line: 2, // 线路
    air_ticket: 3,// 机票
    goods: 4, // 特产商品
    guide: 5, //导服
    visa: 6, // 签证
    combo: 7, // 套餐
    insurance: 8, // 保险
    repast : 9, // 餐饮
    pack: 10, // 套餐
    liner: 12, // 邮轮
}
import {getProductAvaildCounpon} from '@/api/coupons'
export default productMenu

export function marketJumpProduct(target,product, marketType) {

    if (!product && !target) {
        return
    }

    console.log(product, target)

    const productType = parseInt(product.productType) 

    if (productType === productMenu.hotel) {
        // 酒店
    } else if(productType === productMenu.ticket) {
        // 景区门票
        var that = target;
        target.$API.market.getSecResourceDetail(product.productId).then(res=>{
            that.$router.push({
                path: '/home/productDetail/ticket_detail',
                query: { scenicId: res.data.resourceScenicId,marketType:marketType },
            })
        }).catch(err=>{
        })
    } else if(productType === productMenu.line) {
        // 线路
        target.$router.push({
            path: '/home/productDetail/line_detail',
            query: { productId: product.productId ,marketType:marketType},
        })
    } else if(product.productType === productMenu.air_ticket) {
        // 机票

    } else if(productType === productMenu.goods) {
        // 商品
        target.$router.push({
            name: 'localProductDetail',
            query: { ID: product.productId,marketType:marketType },
        })
    } else if(product.productType === productMenu.guide) {
        // 导服

    } else if(product.productType === "6") {
        // 签证
        target.$router.push({
            path: "/visa/visa_detail_new",
            query: {
            //   productCode: item.productCode,
              productId: product.productId,
              marketType:marketType
            //   serviceRegion: item.serviceRegion,
            },
          });
    } else if(productType === productMenu.repast) {
        // 餐饮
        var that = target;
        target.$API.market.getRestaurantByGoodsId(product.productId).then(res=>{
            that.$router.push({
				path: '/restaurant/restaurantDetail',
				query: { ID: res.data.id,marketType:marketType},
			})
        }).catch(err=>{
        })

    }else if(product.productType === "10") {
        // 套餐
        target.$router.push({
            path: "/meal/mealDetail",
            query: { productId: product.productId,marketType:marketType },
          });
    }
}

// 产品对应我的的优惠券列表
export function getUserMaxCounpon(param,callBack) {
        getProductAvaildCounpon(param)
        .then((res) => {
            const couponList = res.data
                .sort((a, b) => {
                    const usable1 = parseInt(b.usable)
                    const usable2 = parseInt(a.usable)

                    const price1 = parseInt(b.kimsPrice)
                    const price2 = parseInt(a.kimsPrice)
                    if (usable1===usable2){
                        return price1 - price2
                    }
                    return usable2 - usable1
                })
                if (couponList && couponList.length){
                    const coupon = couponList[0]
                    if (coupon.usable === '0'){
                        callBack(coupon)
                    }
                    callBack(null)
                }else{
                    callBack(null)
                }
        })
        .catch((err) => {callBack(null)})
}